module.exports = "/_next/static/images/harajuku_organic_top-3a55555cf073eeec6a149be854c6bcc8.jpg";